var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.407 13.058a1.495 1.495 0 0 1 0-2.116L8.04 5.3c.39-.39 1.03-.39 1.42 0 .39.39.39 1.02 0 1.41L6.744 9.427a9.991 9.991 0 0 1-1.768 1.406l-.342.214.208.207A10 10 0 0 1 7.08 11h13.922a1 1 0 1 1 0 2H7.08a10 10 0 0 1-2.24-.254l-.207.206.342.215c.641.4 1.233.872 1.768 1.406L9.46 17.29c.39.39.39 1.02 0 1.41-.39.39-1.03.39-1.42 0l-5.633-5.642Z","fill":"#979797"}));
}

ArrowBack.defaultProps = {"width":"21","height":"21","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
